/* eslint-disable no-undef */
import {
    HttpTransportType,
    HubConnectionBuilder,
    LogLevel,
} from '@aspnet/signalr'
import {http} from './http'

let hub = null
const delay = ms => new Promise(_ => setTimeout(_, ms))

export default class CloudFlyerAPI {
    // auth, storage, mam, accounts, wasabi partner, billing


    static new_user_account = {

        me: () => http.get('/user/userinfo'),

        login: data => http.post(AUTH_API + 'authentication/Login', data),
        request_temp_token: () => http.post(AUTH_API + 'authentication/request_token'),

        logout: () => {
            console.log('logout')
            localStorage.clear()
            //CloudFlyerAPI.rm.stop()
            //return http.delete('/logout')
        },

        request_reset_password: (email, requestToken) => http.post(AUTH_API + '/authentication/forgot_password', {username: email, requestToken}),

        resetPassword: (password, resetToken, requestToken) => http.post(AUTH_API + '/authentication/reset_password', {password, resetToken, requestToken}),

        changePassword: ({old_password, new_password}) => {
            return http.put(AUTH_API + '/users/_me/change_password', {
                old_password: old_password,
                new_password: new_password,
            })
        },
    }

    static user_account = {


        getTransferSummary: filters => http.post('/admin/transfer/get_transfer_summary', filters),

        getTransferRegionSummary: filters => http.post('/admin/transfer/get_transfer_region_summary', filters),

        getTransferHistory: (filters, pageSize, page) => http.post('/admin/transfer/get_transfer_history?pagesize=' + pageSize + '&page=' + page, filters),
        downloadTransferHistory: (body) => http.post('/admin/transfer/download_transfer_history', body),

        downloadAccountReport: () => http.get('/admin/account/download_account_report'),

        addAccount: data => http.post('/admin/account/insert', data),

        fetchAllUsers: (pageSize, page, username) => {
            if (username === "" || username === undefined || username === null) {
                return http.get('/admin/user/get_all?pagesize=' + pageSize + '&page=' + page)
            } else {
                return http.get('/admin/user/get_all?pagesize=' + pageSize + '&page=' + page + '&username=' + username)
            }
        },
        fetchAllAccounts: (pageSize, page, accountName) => {
            if (accountName === "" || accountName === undefined || accountName === null) {
                return http.get('/admin/account/get_all?pagesize=' + pageSize + '&page=' + page)
            } else {
                return http.get('/admin/account/get_all?pagesize=' + pageSize + '&page=' + page + '&name=' + accountName)
            }
        },

        getUsersByAccount: (accountId, pageSize, page) => http.get('/admin/user/get_by_account?accountid=' + accountId + '&pagesize=' + pageSize + '&page=' + page),

        addUser: data => http.post('/admin/user/user_signup', data),

        ActiveStatus: status => http.post('/admin/sync/activate', status),
        resendEmail: id => http.post('/admin/user/resend_email', id),
        deleteUserAPI: id => http.delete('/admin/user/delete?id=' + id),
        deleteAccountAPI: id => http.delete('/admin/account/delete?id=' + id),
    }

    static product_features = {

        addNewFeature: data => http.post('/admin/productfeature/insert', data),
        updateFeature: data => http.post('/admin/productfeature/update', data),
        getAllFeatures: (pageSize, page, deleted) => http.get('/admin/productfeature/get_all?page=' + page + '&pagesize=' + pageSize + '&sortfield=Name&descending=true&deleted=' + deleted),

        deleteFeature: id => http.delete('/admin/productfeature/delete?id=' + id),
    }

    static product_packages = {

        addNewPackage: data => http.post('/admin/productpackage/insert', data),
        updatePackage: data => http.post('/admin/productpackage/update', data),
        getAllPackages: (pageSize, page, deleted) => http.get('/admin/productpackage/get_all?page=' + page + '&pagesize=' + pageSize + '&sortfield=Name&descending=true&deleted=' + deleted),

        deletePackage: id => http.delete('/admin/productpackage/delete?id=' + id),
    }

    static admin_subscription = {

        addNewSubscription: data => http.post('/admin/subscription/insert', data),
        getAllSubscription: (pageSize, page, userID) => http.get('/admin/subscription/get_all?userId='+userID+'&page=' + page + '&pagesize=' + pageSize + '&sortfield=CreateDate&descending=true'),
        updateSubscription: data => http.post('/admin/subscription/update', data),

        deleteSubscription: id => http.delete('/admin/subscription/delete?id=' + id),
    }

    static report_admin = {
        getDashboardReport: (pageSize, page) => http.get('/admin/report/get_dashboard_report'),
        postDashboardChartDate: (startDate, EndDate) => http.get('/admin/report/get_monthly_transfer_stats?from=' + startDate + '&to=' + EndDate),
        postJobTableData: (page, pageSize, filter) => http.post('/admin/transfer/get_transfer_history?page=' + page + '&pagesize=' + pageSize + '&sortfield=RequestDate&descending=' + filter),
        getNotifications: (pageSize, page) => http.get('/admin/notification/get_notifications'),
        postNotifications: data => http.post('/admin/notification/set_notifications', data),
        fetchAllUsers: (pageSize, page) => http.get('/admin/user/get_all?pagesize=' + pageSize + '&page=' + page + '&userStatus=1'),
        fetchAllUsersWithPagination: (pageSize, page) => http.get('/admin/user/get_all_entities?page=' + page + '&pagesize=' + pageSize + '&sortfield=CreateDate&descending=true&deleted=false'),
        fetchAllUsersWithPaginationWithUsername: (pageSize, page, username) => http.get('/admin/user/get_all_entities?page=' + page + '&pagesize=' + pageSize + '&sortfield=CreateDate&descending=true&deleted=false&username=' + username),
        cancelTransfer: data => http.post('/admin/transfer/cancel_transfer', data),
        resumeTransfer: data => http.post('/admin/transfer/resume_transfer', data),
        pauseTransfer: data => http.post('/admin/transfer/pause_transfer', data),
    }
    static sync = {

        fetchAllSync: (showOnlyActive, pageSize, page, userId, accountId) => {
            if (userId === "" && accountId === "") {
                return http.get('/admin/sync/get_all?showonlyactive=' + showOnlyActive + '&pagesize=' + pageSize + '&page=' + page)
            }
            if (userId !== "" && accountId !== "") {
                return http.get('/admin/sync/get_all?showonlyactive=' + showOnlyActive + '&pagesize=' + pageSize + '&page=' + page + '&userId=' + userId + '&accountId=' + accountId)
            }
            if (userId !== "") {
                return http.get('/admin/sync/get_all?showonlyactive=' + showOnlyActive + '&pagesize=' + pageSize + '&page=' + page + '&userId=' + userId)
            }
            if (accountId !== "") {
                return http.get('/admin/sync/get_all?showonlyactive=' + showOnlyActive + '&pagesize=' + pageSize + '&page=' + page + '&accountId=' + accountId)
            }
        }
    }

    static cloud_accounts = {
        types: () => {
            return http.get('/account-types/')
        },

        get: () => {
            return http.get('/cloud_accounts/')
        },

        /* all: () => {
                 return http.get('/cloud_accounts/all');
             },*/

        all: accountId => {
            return http.get('/admin/cloud_account/get_by_account?page=1&pagesize=0&accountid=' + accountId)
        },

        clouds: () => {
            return http.get('/admin/cloud_account/clouds')
        },

        buckets: id => {
            return http.get('/admin/cloud_account/buckets/' + id)
        },

        destroy: id => {
            return http.delete('/cloud_accounts/' + id)
        },

        create: data => {
            /*if (data.cloud_account.account_type_id === 'wasabi') {
                    return new Promise((resolve, reject) => {
                      let account = {
                        project_name: data.cloud_account.project_name,
                        account_type_id: data.cloud_account.account_type_id,
                        user_id: 127,
                        billing_bucket: 'billing_bucket',
                        db: 0,
                        total_bytes_used: 1024,
                        total_cost: 0,
                        user_count: 0,
                        bucket_count: 0,
                        per_gb: 0,
                        id: 0,
                        created_on: "2017-11-13T14:52:12Z",
                        modified_on: "0001-01-01T00:00:00Z",

                        dbs: {
                          dynamo: 0,
                          rds: 0
                        },

                        vm: {
                          running: 0,
                          stopped: 0
                        },

                        info: {
                          access_key: data.cloud_account.info.access_key_id,
                          secret_key: data.cloud_account.info.secret_access_key,
                          region: "us-east-1",
                          endpoint: 's3.wasabisys.com'
                        },

                        storages: []
                      }

                      localStorage.setItem('wasabi_account', JSON.stringify(account))
                      resolve(account)
                    })
                  }*/

            return http.post('/cloud_accounts/', data)
        },

        wasabi_account: () => {
            let account = JSON.parse(window.localStorage.getItem('wasabi_account'))
            if (!account) {
                return new Promise(resolve => {
                    resolve()
                })
            }

            window.AWS.config.update({
                accessKeyId: account.info.access_key,
                secretAccessKey: account.info.secret_key,
                region: account.info.region,
            })

            let s3 = new window.AWS.S3({
                apiVersion: '2006-03-01',
                endpoint: account.info.endpoint,
            })

            return new Promise((resolve, reject) => {
                s3.listBuckets(function (err, data) {
                    if (err) {
                        return reject(err)
                    }

                    account.bucket_count = data.Buckets.length
                    account.storages = data.Buckets.map((bucket, index) => {
                        return {
                            bucket_name: bucket.Name,
                            CreationDate: bucket.created_on,
                            region: account.info.region,
                            size: 0,
                            cost: 0,
                            id: index,
                        }
                    })
                    resolve(account)
                })
            })
        },

        update: function (cloud_account_id, project_name, info, billing_bucket) {
            let payload = {
                project_name: project_name, //,
                //info         : info
            }

            if (billing_bucket) {
                payload.billing_bucket = billing_bucket
            }

            return http.put('/cloud_accounts/' + cloud_account_id, {
                cloud_account: payload,
            })
        },

        summary: () => {
            return http.get(ANALYTICS_API + 'CloudAccount/Summary')
        },

        setBillingBucket: (cloud_account_id, bucketName) => {
            return http.put(
                '/cloud_accounts/' + cloud_account_id + '/update_billing_report_bucket',
                {
                    billing_bucket: bucketName,
                }
            )
        },

        credentials: account_id => {
            if (account_id === undefined) {
                return http.get('/cloud_accounts/access_info')
            }
            return http.get('/cloud_accounts/' + account_id + 'access_info')
        },

        users: id => http.get('/cloud_accounts/' + id + '/users'),

        validate_bucket_name: (id, bucket_name, account_type) =>
            http.get(
                '/cloud_accounts/' +
                id +
                '/storages/exists?bucket_name=' +
                bucket_name +
                '&account_type=' +
                account_type
            ),
    }

    static dashboard = {
        //get: (bp) => http.get(ANALYTICS_API+'dashboard/&breakPoint='+bp),
        get: () => http.get(ANALYTICS_API + 'dashboard'),
        put: data => http.put(ANALYTICS_API + 'dashboard/create', data),
        put_all: data => http.put(ANALYTICS_API + 'dashboard/createAll', data),
        delete: id => http.delete(ANALYTICS_API + 'dashboard?id=' + id),
    }

    static desktop = {
        registerStandaloneLicense: data =>
            http.post(DESKTOP + '/api/standalone/RegisterTrialLicense/', data),

        standaloneLicensePay: data =>
            http.post(DESKTOP + '/api/standalone/licensepay/', data),
    }

    static billing = {
        request_quote: (package_id, message) =>
            http.post('/packages/request_quote', {
                message: message,
                package_id: package_id,
            }),

        subscriptions: data => http.post('/billing/subscriptions/', data),

        desktopSubscriptions: data =>
            http.post('/billing/desktop/subscriptions/new_customer', data),

        getProducts: () => http.get('/billing/products'),

        packages: () => http.get('/packages'),

        getSubscription: subscriptionId =>
            http.get('/billing/subscriptions/' + subscriptionId),

        changePlan: (productHandle, subscriptionId) =>
            http.put(
                '/billing/subscriptions/' +
                subscriptionId +
                '/product_change/' +
                productHandle
            ),

        getPaymentsHistory: subscriptionId =>
            http.get('/billing/events/subscription/' + subscriptionId),

        billing_info: () => http.get('/billing/billing_info'),

        fetchPaymentProfiles: () => http.get('/billing/payment_profiles'),

        addCreditCard: ({
                            billing_address,
                            billing_city,
                            billing_state,
                            billing_zip,
                            billing_country,
                            billing_address_2,
                            payement_type,
                            full_number,
                            profile_name,
                            expiration_month,
                            expiration_year,
                            first_name,
                            last_name,
                        }) =>
            http.post('/billing/payment_profiles', {
                profile_create_params: {
                    payment_profile: {
                        billing_address,
                        billing_city,
                        billing_state,
                        billing_zip,
                        billing_country,
                        billing_address_2,
                        payment_type: 'credit_card',
                        full_number,
                        profile_name: '',
                        expiration_month,
                        expiration_year,
                        first_name,
                        last_name,
                    },
                },
            }),

        updateCreditCardInfo: function (paymentId, info) {
            return http.put('/billing/payment_profiles/' + paymentId, {
                profile_update_params: {payment_profile: info},
            })
        },

        delete: id => http.delete('/billing/subscriptions/' + id),

        reactivate: id => http.put('/billing/subscriptions/' + id + '/reactivate'),

        change_card: (subscription_id, payment_profile) => {
            return http.post('/billing/payment_profiles/' + subscription_id, {
                profile_create_params: {
                    payment_profile: payment_profile,
                },
            })
        },

        validate: promo_code => http.get('/billing/coupons/validate/' + promo_code),
    }

    static storages = {
        directories: (id, bucket_name, path) =>
            http.get(
                ANALYTICS_API +
                'FilesSystem/directories?id=' +
                (id || '') +
                '&bucketName=' +
                (bucket_name || '') +
                '&path=' +
                (path || '')
            ),

        getStorageList: () => http.get('/storages'),

        getFilesByPath: (
            id,
            path,
            limit,
            last_file_basename,
            continuation_token
        ) => {
            if (!id) {
                return Promise.resolve()
            }

            if (path === null) {
                path = '/'
            }

            let url_path = '/content?'

            if (limit) {
                url_path = url_path + 'limit=' + limit
            } else {
                url_path = url_path + 'limit=' + 15
            }

            if (path) {
                url_path = url_path + '&path=' + path
            }

            if (last_file_basename) {
                url_path = url_path + '&last_file=' + last_file_basename
            }

            if (continuation_token) {
                url_path += '&continuation_token=' + continuation_token
            }

            return http.get(`/storage/${id}${url_path}`)
        },

        getToken: (id, data, type) =>
            http.post('/storage/' + id + '/content/' + type, data),

        fileTransfer: data => http.post('/transfer/', data),

        download: (id, data) =>
            http.post('/storage/' + id + '/content/download', data),

        upload: (id, data) => http.post('/storage/' + id + '/content/upload', data),

        get: id => http.get('/storage/' + id),

        create: (cloud_account_id, body) =>
            http.post('/cloud_accounts/' + cloud_account_id + '/storages', body),

        search: body => http.post('/search', body),
    }

    static slack = {
        start: () => http.get(ANALYTICS_API + 'slack/start'),

        authorize: code =>
            http.get(ANALYTICS_API + 'slack/authorize?code=' + (code ? code : '')),

        history: id => http.get(ANALYTICS_API + 'slack/history/' + id),

        channels: () => http.get(ANALYTICS_API + 'slack/channels'),

        logout: () => http.delete(ANALYTICS_API + 'slack/logout'),
    }

    static file_catalyst = {
        user: () => http.get('/file_catalyst/user'),

        settings: () => http.get('/file_catalyst/settings'),

        delete: username => http.delete('/file_catalyst/user/' + username),

        post_url: () => http.post('/file_catalyst/post_url'),

        costs: (
            service_code, // or CloudFlyer_transfer, aspera_transfer
            size, // in bytes
            direction // or download
        ) =>
            http.post('/transfers/costs', {
                service_code: service_code,
                size: size,
                direction: direction,
            }),

        transfer_agent: {
            connect: (remoteServer, remotePort, username, password) => {
                return http.get(FC_BASE_URL + 'agent/connect', {
                    params: {
                        remoteServer: remoteServer,
                        remotePort: remotePort,
                        username: username,
                        password: password,
                        remoteDirectory: '',
                        usesSSL: false,
                        createDirectoryOnConnect: true,
                        lockInitialDirectory: false,
                    },
                })
            },

            heartbeat: tick => {
                return http.get(FC_BASE_URL + 'agent/heartbeat', {
                    params: {
                        _: tick,
                    },
                })
            },

            version: (version, tick) => {
                return http.get(FC_BASE_URL + 'agent/version', {
                    params: {
                        requester: '3.7.1+3+19',
                        _: tick,
                    },
                })
            },

            launch: () => {
                return new Promise((resolve, reject) => {
                    try {
                        let iframe = document.getElementById('launchFrame')

                        if (!iframe) {
                            iframe = document.createElement('iframe')
                            iframe.style.display = 'none'
                            iframe.id = 'launchFrame'
                            iframe.src = 'about:blank'
                            document.body.appendChild(iframe)
                        }
                        iframe.src = 'filecatalyst://localhost'
                        resolve()
                    } catch (e) {
                        reject(e)
                    }
                })
            },
        },

        transfers: {
            //http://download.filecatalyst.com/download/filesFCDirect/current/documentation/restapi/transferagent/restDocs/ui/index.html#/

            status: transfer_id => {
                if (transfer_id) {
                    return http.get(FC_BASE_URL + 'agent/status/' + transfer_id)
                }

                return http.get(FC_BASE_URL + 'agent/status')
            },

            cancel: transfer_id =>
                http.get(FC_BASE_URL + 'files/transferRev1/cancel', {
                    params: {
                        transferID: transfer_id,
                    },
                }),

            transfer_legacy: (
                source_connection_key,
                destination_connection_key,
                files,
                local_working_directory,
                remote_directory
            ) => {
                return http.post(FC_BASE_URL + 'files/transferRev1', {
                    BlockSize: 5242880,
                    NumberOfClients: 5,
                    PostURL:
                        'https://api.CloudFlyer.com/file_catalyst/post_url/?user_id=84&direction=upload&transfer_date=Thu%2C%2016%20Nov%202017%2009%3A49%3A27%20GMT&acl=private&bucket_name=CloudFlyer-test-8&anti_duplication_token=VGh1JTJDJTIwMTYlMjBOb3YlMjAyMDE3JTIwMDklM0E0OSUzQTI3JTIwR01UODR1cGxvYWRjYXRhbHlzdF90cmFuc2ZlcjYzMzA1Njc4OC40OA==',
                    RemoteDirectory: remote_directory,
                    SendEmailNotification: false,
                    SentFilelistInEmail: false,
                    TransferWithTempName: false,
                    UseCongestionControl: true,
                    VerifyIntegrity: false,
                    VerifyMode: 0,
                    DestinationConnectionKey: destination_connection_key,
                    LocalWorkingDirectory: local_working_directory,
                    SourceConnectionKey: source_connection_key,
                    WeblinkID: '',
                    fileList: files,
                    jobId: '',
                    transferConfiguration: {},
                })
            },

            transfer: (
                source_connection_key,
                destination_connection_key,
                files,
                local_working_directory,
                remote_directory,
                user_id,
                direction
            ) => {
                let transfer_date = encodeURIComponent(new Date().toUTCString())
                let postURL =
                    API +
                    '/file_catalyst/post_url/?user_id=' +
                    user_id +
                    '&direction=' +
                    direction +
                    '&transfer_date=' +
                    transfer_date +
                    '&bucket_name=' +
                    (local_working_directory
                        ? local_working_directory
                        : remote_directory) +
                    '&anti_duplication_token=' +
                    window.btoa(
                        transfer_date +
                        user_id +
                        direction +
                        (local_working_directory
                            ? local_working_directory
                            : remote_directory)
                    )

                return http.post(FC_BASE_URL + 'files/transferRev1', {
                    DestinationConnectionKey: destination_connection_key,
                    LocalWorkingDirectory: local_working_directory,
                    SourceConnectionKey: source_connection_key,
                    fileList: files,
                    WeblinkID: null,
                    jobId: null,

                    transferConfiguration: {
                        BlockSize: 5242880,
                        NumberOfClients: 5,
                        PostURL: postURL,
                        RemoteDirectory: remote_directory,
                        SendEmailNotification: false,
                        SentFilelistInEmail: false,
                        TransferWithTempName: false,
                        UseCongestionControl: true,
                        VerifyIntegrity: false,
                        VerifyMode: 0,

                        /*"IncrementalSizeCheckOnly" : true,
                                    "AutoResume" : true,
                                    "AutoZip" : true,
                                    "CompFileFilter" : "...",
                                    "CongestionControlAggression" : 12345.0,
                                    "CongestionControlStrategy" : 12345.0,
                                    "ConnectTimeout" : 12345.0,
                                    "DeleteAfterTransfer" : true,
                                    "EmailAddress" : "...",
                                    "EmailBody" : "...",
                                    "ExtendedReadTimeout" : 12345.0,
                                    "IncrementalMode" : 12345.0,
                                    "MaintainLastModified" : true,
                                    "MaintainPermissions" : true,
                                    "MaxRetries" : 12345.0,
                                    "Md5RateLimit" : 12345.0,
                                    "Mode" : 12345.0,
                                    "NumBlockReaders" : 12345.0,
                                    "NumBlockWriters" : 12345.0,
                                    "NumFTPStreams" : 12345.0,
                                    "NumPacketProcessors" : 12345.0,
                                    "NumReceiveSockets" : 12345.0,
                                    "NumSenderSockets" : 12345.0,
                                    "NumThreads" : 12345.0,
                                    "OptimizeBlockSize" : true,
                                    "PacketQueueDepth" : 12345.0,
                                    "PacketSize" : 12345.0,
                                    "ProgressiveTimeout" : 12345.0,
                                    "ProgressiveTimeoutFilter" : "...",
                                    "ProgressiveTransfers" : true,
                                    "ReadBufferSize" : 12345.0,
                                    "ReadTimeout" : 12345.0,
                                    "SendEmailNotificationPerFile" : true,
                                    "StartRate" : 12345.0,
                                    "TargetRate" : 12345.0,
                                    "TransferEmptyDirectories" : true,
                                    "TransferRate" : 12345.0,
                                    "UseCompression" : true,
                                    "UseIncremental" : true,
                                    "UseSSL" : true,
                                    "WaitRetry" : 12345.0,
                                    "WriteBufferSize" : 12345.0,
                                    "ZipFileSizeLimit" : 12345.0*/
                    },
                })
            },

            transfer_one: (
                source_connection_key,
                destination_connection_key,
                source_file,
                destination_file,
                remote_directory
            ) => {
                return http.post(FC_BASE_URL + 'files/transferRev1', {
                    DestinationConnectionKey: destination_connection_key,
                    RemoteDirectory: remote_directory,
                    SourceConnectionKey: source_connection_key,
                    sourceFile: source_file,
                    destinationFile: destination_file,
                    jobId: '',
                    transferConfiguration: {},
                })
            },

            upload: (files, remote_directory, connection_key, user_id) =>
                CloudFlyerAPI.file_catalyst.transfers.transfer(
                    'local',
                    connection_key,
                    files,
                    '',
                    remote_directory,
                    user_id,
                    'upload'
                ),

            download: (files, local_directory, connection_key, user_id) =>
                CloudFlyerAPI.file_catalyst.transfers.transfer(
                    connection_key,
                    'local',
                    files,
                    local_directory,
                    '',
                    user_id,
                    'download'
                ),

            share: (files, recipients, connection_key) => {
                return http.post(FC_BASE_URL + 'agent/weblink', {
                    connectionKey: connection_key,
                    fileListing: files,
                    subject: 'New Files',
                    userMessage: 'Files Sharing',
                    toEmailAddress: recipients,
                    weblinkID: 'weblinkID',
                })
            },
        },

        files: {
            local: path => {
                if (typeof path === 'undefined' || path === null) {
                    path = ''
                }

                if (path.length > 0 && !path.startsWith('/')) {
                    path = '/' + path
                }

                return http.get(FC_BASE_URL + 'files/local' + path, {
                    params: {
                        sortby: 'name',
                        invert: false,
                        connectionKey: 'local',
                    },
                })
            },

            create_directory: (filePath, connectionKey) => {
                if (filePath.length > 0 && !filePath.startsWith('/')) {
                    filePath = '/' + filePath
                }

                let path =
                    (connectionKey ? 'files/remotefile' : 'files/localfile') + filePath

                return http.put(FC_BASE_URL + path)
            },

            delete_file: (filePath, connectionKey) => {
                if (filePath.length > 0 && !filePath.startsWith('/')) {
                    filePath = '/' + filePath
                }

                let path =
                    (connectionKey ? 'files/remotefile' : 'files/localfile') + filePath

                return http.delete(FC_BASE_URL + path)
            },

            delete_files: (files_paths, connectionKey) => {
                for (let key in files_paths) {
                    if (
                        files_paths[key].length > 0 &&
                        !files_paths[key].startsWith('/')
                    ) {
                        files_paths[key] = '/' + files_paths[key]
                    }
                }

                let path = connectionKey ? 'files/remotefile' : 'files/localfile'

                return http.delete(FC_BASE_URL + path, {
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({ids: files_paths}),
                })
            },
        },
    }

    static notifications = {
        all: () => http.get('/notifications'),

        notifies: () => {
            let ngrok = 'http://607186be.ngrok.io/api/'
            return http.get(ANALYTICS_API + 'notifications/all') //ANALYTICS_API
        },

        read: notification_ids => {
            let ngrok = 'http://607186be.ngrok.io/api/'
            return http({
                url: ANALYTICS_API + 'notifications/read',
                method: 'PUT',
                params: {ids: notification_ids},
                paramsSerializer: ({ids}) => {
                    let param = ''
                    for (let key in ids) {
                        let item = ids[key]
                        param += 'ids=' + item + '&'
                    }
                    if (param.endsWith('&')) {
                        param = param.slice(0, -1)
                    }
                    return param
                },
            })
        },

        by_cloud_account: account_id => {
            return http.get('/cloud_accounts/' + account_id + '/notifications')
        },

        by_storage: storage_id => {
            return http.get('/storages/' + storage_id + '/notifications')
        },

        create: (cloud_account_id, bucket_name, MaxSize, MaxCost) => {
            let request = {
                notification: {
                    cloud_account_id: cloud_account_id,
                    service: 'S3',
                },
            }

            if (bucket_name) {
                request.notification.bucket_name = bucket_name
            }

            let promises = []

            if (MaxSize) {
                let newRequest = Object.assign({}, request)
                newRequest.notification.size_limit = MaxSize
                promises.push(http.post('/notifications/', newRequest))
            }
            if (MaxCost) {
                let newRequest = Object.assign({}, request)
                newRequest.notification.cost_limit = MaxCost
                promises.push(http.post('/notifications/', newRequest))
            }
            return Promise.all(promises)
        },

        delete: notification_id => {
            return http.delete('/notifications/' + notification_id)
        },
    }

    static transfer = {
        s3_url_signer_v4: () => http.get('/transfers/s3_url_signer_v4'),

        s3_costs: () => http.get('/transfers/s3_costs'),

        report: data => http.post('/transfers/report', data),

        update_bucket_config: (
            cors,
            s3Acceleration,
            cleanup_incomplete_multipart_lifecycle_rule,
            cloud_account_id,
            bucket_name
        ) =>
            http.put('/transfers/update_bucket_config/', {
                cors: cors,
                s3Acceleration: s3Acceleration,
                cloud_account_id: cloud_account_id,
                bucket_name: bucket_name,
                cleanup_incomplete_multipart: cleanup_incomplete_multipart_lifecycle_rule,
            }),

        summary: (start_date, end_date, service) =>
            http.get('/transfers/summary', {
                params: {
                    start_date: start_date,
                    end_date: end_date,
                    service: service,
                },
            }),

        history: (page, limit, service) =>
            http.get('/transfers/history', {
                params: {limit: limit, page: page, service: service},
            }),

        share_by_email_files: body =>
            http.post('/transfers/share_files_by_email', body),

        share_by_slack_files: (files, channel) =>
            http.post(ANALYTICS_API + 'slack/share', {files, channel}), //ANALYTICS_API //'http://f7153c4b.ngrok.io/api/'

        download_url: (cloud_account_id, bucket_name, file_names) =>
            http({
                url: '/transfers/download_url',
                method: 'GET',
                params: {
                    cloud_account_id: cloud_account_id,
                    bucket_name: bucket_name,
                    file_names: file_names,
                },
            }),

        delete_object: (cloud_account_id, bucket_name, file_names) =>
            http({
                url: '/transfers/delete_object',
                method: 'DELETE',
                params: {
                    cloud_account_id: cloud_account_id,
                    bucket_name: bucket_name,
                    file_names: file_names,
                },
            }),

        create_folder: (cloud_account_id, bucket_name, folder_name) => {
            folder_name = folder_name.replace(/^\/+/g, '')
            folder_name = folder_name.replace(/([^:]\/)\/+/g, '$1')
            return http({
                url: '/transfers/create_folder',
                method: 'PUT',
                params: {
                    cloud_account_id: cloud_account_id,
                    bucket_name: bucket_name,
                    folder_name: folder_name,
                },
            })
        },

        migration: {
            move: (payload) => http.post(BE_API + 'admin/transfer/transfer', payload),
            moveAWS: (files = []) => http.post(ANALYTICS_API + 'c2c/moveaws', files),
            moveAWS2: (files = []) => http.post(ANALYTICS_API + 'c2c/MoveAWSProd3', files),
            moveWasabi: (files = []) => http.post(ANALYTICS_API + 'c2c/moveWasabi', files),
            historyAWS: (user_Id) => {
                return http.get('https://c2c-status.CloudFlyer.com/api/report?userId=' + user_Id)
            },
            downloadFailedFile: (batchTransferId) => {
                return http.post('https://c2c-status.CloudFlyer.com/api/report?batchTransferId=' + batchTransferId)
            },
            retryAWS: (migration = []) => http.post('https://c2c.CloudFlyer.com/transfer/transfer', migration),
            historyWasabi: (user_Id) => {
                return http.get('https://c2c-status-wasabi.CloudFlyer.com/api/report?userId=' + user_Id)
            },
            downloadFailedFileWasabi: (batchTransferId) => {
                return http.post('https://c2c-status-wasabi.CloudFlyer.com/api/report?batchTransferId=' + batchTransferId)
            },
            retryWasabi: (migration = []) => http.post('https://c2c-wasabi.CloudFlyer.com/transfer/transfer', migration),

            history: (order, skip, take) => {
                let url = ANALYTICS_API + 'c2c/history?'
                if (order) url += '&order=' + order
                if (skip) url += '&skip=' + skip
                if (take) url += '&take=' + take
                return http.get(url)
            },

            usage: (from, to) =>
                http.get(`${ANALYTICS_API}c2c/usage?from=${from}&to=${to}`),

            cancel: (id = '') =>
                http.get(ANALYTICS_API + 'c2c/cancel?migrationId=' + id),
        },
    }

    static encoding = {
        presets: () => http.get(TRANSCODE_API_URL + '/transcode/presets/'),

        cancel: jobId =>
            http.delete(
                TRANSCODE_API_URL + '/jobs/' + (jobId ? jobId : '') + '/cancel'
            ),

        remove: jobId =>
            http.delete(TRANSCODE_API_URL + '/jobs/' + (jobId ? jobId : '')),

        encode: data => http.post(TRANSCODE_API_URL + '/transcode/', data),

        status: jobId =>
            http.get(TRANSCODE_API_URL + '/jobs/' + (jobId ? jobId : '') + '/status'),

        jobs: jobId => {
            if (jobId) {
                return http.get(TRANSCODE_API_URL + '/jobs/' + jobId)
            }

            return http.get(TRANSCODE_API_URL + '/jobs/')
        },
    }

    static packages = {
        request_quote: (package_id, message) =>
            http.post('/packages/request_quote', {
                message: message,
                package_id: package_id,
            }),
        request_service: (service_name, plan) =>
            http.post('/packages/request_service', {
                service_name,
                plan,
            }),
    }

    static analytics = {
        overview: (cloudId, month) => {
            return http.get(
                `${ANALYTICS_API}analytics?cloudId=${cloudId}&month=${month}`
            )
        },
        product: (cloudId, product) => {
            return http.get(
                `${ANALYTICS_API}analytics/product?cloudId=${cloudId}&product=${product}`
            )
        },
        AwsAllocationMonthlyCost: {
            GetProductCost: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetProductCost?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAwsS3: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsS3?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAwsEC2: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsEC2?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAwsDataTransfer: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsDataTransfer?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAwsCloudWatch: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsCloudWatch?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAwsRDS: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsRDS?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAwsEFS: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsEFS?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },
            GetAwsRoute53: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAwsRoute53?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAWSSupportBusiness: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAWSSupportBusiness?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetAWSDirectConnect: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsAllocationMonthlyCost/GetAWSDirectConnect?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },
        },

        AwsDetailMonthlyCost: {
            GetRDSCost: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsDetailMonthlyCost/GetRDSCost?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },

            GetBucketCost: function (accountId, month) {
                return http.get(
                    ANALYTICS_API +
                    'AwsDetailMonthlyCost/GetBucketCost?awsAccountId=' +
                    accountId +
                    '&month=' +
                    month
                )
            },
        },

        AwsEc2: {
            GetEC2Instance: function (accountId) {
                return http.get(
                    ANALYTICS_API + 'awsEc2/getEC2instance?awsAccountId=' + accountId
                )
            },
        },

        AwsEFS: {
            GetEFSInstance: function (accountId) {
                return http.get(
                    ANALYTICS_API + 'awsEFS/getEFSinstance?awsAccountId=' + accountId
                )
            },
        },
    }

    static finance = {
        yearly: (cloudid = '', year) =>
            http.get(
                `${ANALYTICS_API}budget/yearly?cloudId=${cloudid || ''}&year=${
                    year ? year.toISOString() : ''
                }`
            ),

        hierarchical: (cloudid = '', year) =>
            http.get(
                `${ANALYTICS_API}budget/Hierarchical?cloudId=${cloudid || ''}&year=${
                    year ? year.toISOString() : ''
                }`
            ),

        monthly: (cloudid = '', month) =>
            http.get(
                `${ANALYTICS_API}budget/monthly?cloudId=${cloudid || ''}&month=${
                    month ? month.toISOString() : ''
                }`
            ),

        set_alert: body => http.put(ANALYTICS_API + 'budget/setAlert', body),

        put: (cloud = '', product = '', actual, budget, yearly, start, end) =>
            http.put(
                `${ANALYTICS_API}budget/put?cloud=${cloud ||
                ''}&product=${product}&actual=${actual || ''}&budget=${budget ||
                ''}&yearly=${yearly}&start=${start ? start.toISOString() : ''}&end=${
                    end ? end.toISOString() : ''
                }`
            ),

        budget: (cloud = '', product = '') =>
            http.get(
                `${ANALYTICS_API}budget?cloud=${cloud || ''}&product=${product}`
            ),

        settings: () => http.get(ANALYTICS_API + 'budget/settings'),

        put_settings: body => http.put(ANALYTICS_API + 'budget/settings', body),

        save_product: body => http.put(ANALYTICS_API + 'budget/Product', body),

        tree: () => http.get(ANALYTICS_API + 'budget/tree'),

        chart: (cloudid = '', year) =>
            http.get(
                `${ANALYTICS_API}budget/chart?cloudId=${cloudid || ''}&year=${
                    year ? year.toISOString() : ''
                }`
            ),

        alerts: () => http.get(ANALYTICS_API + 'budget/alerts'),

        delete_alert: id =>
            http.delete(`${ANALYTICS_API}budget/alert?id=${id || ''}`),

        budgets: () => http.get(ANALYTICS_API + 'budgets/request_extension'),
        audits: (from, to, entities, users, skip, take) =>
            http.get(`${ANALYTICS_API}audits/logs`, {
                params: {from, to, entities, users, skip, take},
                paramsSerializer: ({from, to, entities, users, skip, take}) => {
                    let param = `from=${from}&to=${to}&skip=${skip}&take=${take}&`
                    for (let key in entities) {
                        let item = entities[key]
                        param += 'entities=' + item + '&'
                    }
                    for (let key in users) {
                        let item = users[key]
                        param += 'users=' + item + '&'
                    }
                    if (param.endsWith('&')) {
                        param = param.slice(0, -1)
                    }
                    return param
                },
            }),
        filters: () => http.get(`${ANALYTICS_API}audits/filters`),
    }

    static rm = {
        open: () => {
            if ((!hub || (hub && hub.stopped)) && localStorage.Authorization) {
                hub = new HubConnectionBuilder()
                    .configureLogging(LogLevel.Error)
                    .withUrl(
                        `${BE_API}rm?access_token=${localStorage.Authorization}`,
                        {accessTokenFactory: () => localStorage.Authorization}
                    ) //transport:HttpTransportType.WebSockets, skipNegotiation:true
                    .build()
                hub
                    .start()
                    .then(() => delete hub.stopped)
                    .catch(e => {
                        hub = null
                        console.error(e)
                    })
                hub.onclose(async () => {
                    if (!hub) return
                    hub.stopped = true
                    if (hub.stopping) {
                        console.log('RTM Stopped')
                    } else {
                        hub = null
                        console.error('RTM Failed')
                        /*while (!hub && localStorage.Authorization) {
                                      console.log('retrying rm ...')
                                      CloudFlyerAPI.rm.open()
                                      await new Promise(resolve => setTimeout(resolve, 1000))
                                    }*/
                    }
                })
            }
            return hub
        },

        on: func => {
            if (CloudFlyerAPI.rm.open()) hub.on('rm', func)
        },

        stop: () => {
            if (CloudFlyerAPI.rm.open()) {
                hub.stopping = true
                hub.stop()
                hub = null
                console.log('RTM stopped')
            }
        },
    }

    static quota = {
        request_extension: message =>
            http.post('/quota/request_extension', {message}),
    }

    static metadata = {
        save: metadata => http.post(ANALYTICS_API + 'metadata/Add', metadata),

        delete: (cloud, storage, path, name) => {
            let params = JSON.stringify({cloud, storage, path, name})
            return http.delete(ANALYTICS_API + 'metadata/delete', {
                params,
                headers: {'Content-Type': 'application/json'},
                data: params,
            })
        },

        all: (cloud, storage, path, format, file_id) =>
            http.get(
                `${ANALYTICS_API}metadata/all?cloud=${cloud}&storage=${storage}&path=${path}&format=${format}&fileId=${file_id}`
            ),
    }

    static hybrik = {
        fetchProfiles: () => http.get('/hybrik/profiles'),
        createProfile: formData => http.post('/hybrik/profiles', formData),
        deleteProfile: id => http.delete('/hybrik/profiles/' + id),
        fetchJobs: status => http.get('/hybrik/jobs?status=' + status),
        createJob: body => http.post('/hybrik/jobs', body),
    }

    static wasabi = {
        create: data => http.post('/wasabi_sub_accounts', data),

        add: data => http.post('/cloud_accounts/', data),
    }

    static sharing = {
        info: id => http.get('/sharing/' + (id || '')),

        verify_password: data => http.post('/sharing/verify_password', data),
    }

    static ftx = {
        launch: () =>
            new Promise(async (resolve, reject) => {
                try {
                    let iframe = document.getElementById('launchFrame')

                    if (!iframe) {
                        iframe = document.createElement('iframe')
                        iframe.style.display = 'none'
                        iframe.id = 'launchFrame'
                        iframe.src = 'about:blank'
                        document.body.appendChild(iframe)
                    }
                    iframe.src = 'ftx://localhost'
                    await delay(2000)
                    resolve()
                } catch (e) {
                    reject(e)
                }
            }),

        connect: () =>
            http.get(
                `${FTX_LOCAL}ftx/Connect?ftxServerAddress=${FTX_HOST}&ftxServicePort=${FTX_PORT}`
            ),

        files: (path, skip, limit) =>
            http.get(
                FTX_LOCAL +
                'ftx/GetContents?limit=' +
                (limit || '100') +
                '&skip=' +
                (skip || '0') +
                '&path=' +
                (path || '')
            ),

        GetLocalDrives: () => http.get(`${FTX_LOCAL}ftx/GetLocalDrives`),

        GetStatus: id => http.get(`${FTX_LOCAL}ftx/GetStatus?id=${id}`),

        move: migration => http.post(`${FTX_LOCAL}ftx/Send`, migration),
    }

    static mam = {
        search: body => http.post('/search', body),

        createProxyFiles: body => http.post('/search/proxy_files_locations/', body),

        getProxyFiles: () => http.get('/search/proxy_files_locations/'),

        findProxyFiles: body => http.post('/search/proxy_files', body),
    }

    static backblaze = {
        authorize: (cloud, cancelToken) =>
            http.get(`${ANALYTICS_API}CloudAccount/backblaze/authorize/${cloud}`, {
                cancelToken: cancelToken,
            }),

        initiate_upload: (cloud, bucketId, fileName, concurrency, cancelToken) =>
            http.get(
                `${ANALYTICS_API}CloudAccount/initiateUpload/${bucketId}?filename=${fileName}&concurrency=${concurrency}`,
                {cancelToken: cancelToken}
            ),

        part_url: (count, url, authorization, file_id, cancelToken) =>
            http.post(
                `${ANALYTICS_API}CloudAccount/PartUrl?count=${count}`,
                {
                    url,
                    authorization,
                    file_id,
                },
                {cancelToken: cancelToken}
            ),

        upload_url: (cloud, bucketId, cancelToken) =>
            http.get(`${ANALYTICS_API}CloudAccount/uploadUrl/${bucketId}`, {
                cancelToken: cancelToken,
            }),

        upload_part: ({
                          url,
                          authorization,
                          part,
                          sha1,
                          stream,
                          progress,
                          cancelToken,
                      }) => {
            return http.post(`${url}`, stream, {
                headers: {
                    Authorization: authorization,
                    'X-Bz-Part-Number': part,
                    'X-Bz-Content-Sha1': sha1,
                },
                cancelToken,
                onUploadProgress: progressEvent => progress(progressEvent),
            })
        },

        upload: ({url, token, file, file_name, sha1, progress, cancelToken}) => {
            return http.post(`${url}`, file, {
                headers: {
                    Authorization: token,
                    'X-Bz-File-Name': encodeURIComponent(file_name),
                    'X-Bz-Content-Sha1': sha1,
                    'Content-Type': file.type,
                },
                cancelToken,
                onUploadProgress: progressEvent => progress(progressEvent),
            })
        },

        finish_upload: (cloud_id, file_id, sha1s, cancelToken) =>
            http.post(
                `${ANALYTICS_API}CloudAccount/finishUpload/${cloud_id}`,
                {
                    file_id,
                    sha1s,
                },
                {cancelToken: cancelToken}
            ),

        parts: (cloud, file_id, cancelToken) =>
            http.get(
                `${ANALYTICS_API}CloudAccount/parts?cloud=${cloud}&fileId=${file_id}`,
                {cancelToken: cancelToken}
            ),

        verify_part: (part, size, sha1, cloud, file_id, cancelToken) =>
            http.get(
                `${ANALYTICS_API}CloudAccount/verifyPart/${cloud}?fileId=${file_id}&part=${part}&size=${size}&sha1=${sha1}`,
                {cancelToken: cancelToken}
            ),

        cancel: (cloud, file_id) =>
            http.delete(`${ANALYTICS_API}CloudAccount/cancel/${cloud}/${file_id}`),

        apply_cors: (cloud, bucket_id, cancelToken) =>
            http.get(`${ANALYTICS_API}CloudAccount/applyCors/${bucket_id}`, {
                cancelToken: cancelToken,
            }),
    }


    static new_cloud_accounts = {
        types: () => {
            return http.get('/account-types/')
        },
        get: () => {
            return http.get('/cloud_accounts/')
        },
        all: (accountId) => {
            return http.get('/admin/cloud_account/get_by_account?pagesize=0&accountid=' + accountId)
        },
        clouds: (accountId) => {
            return http.get('/admin/cloud_account/get_by_account?pagesize=0&accountid=' + accountId)
        },
        fetchObjectsList: async (payload) => {
            return http.post('/admin/cloud_account/list_objects', payload)
        },
        buckets: async (payload) => {
            return http.post('/admin/cloud_account/list_buckets', payload)
        },
        destroy: id => {
            return http.delete('/cloudaccount/delete?id=' + id)
        },
        create: data => {
            console.log("herererererre");
            return http.post('/cloudaccount/insert', data)
        },
        wasabi_account: () => {
            let account = JSON.parse(window.localStorage.getItem('wasabi_account'))
            if (!account) {
                return new Promise(resolve => {
                    resolve()
                })
            }
            window.AWS.config.update({
                accessKeyId: account.info.access_key,
                secretAccessKey: account.info.secret_key,
                region: account.info.region,
            })
            let s3 = new window.AWS.S3({
                apiVersion: '2006-03-01',
                endpoint: account.info.endpoint,
            })
            return new Promise((resolve, reject) => {
                s3.listBuckets(function (err, data) {
                    if (err) {
                        return reject(err)
                    }

                    account.bucket_count = data.Buckets.length
                    account.storages = data.Buckets.map((bucket, index) => {
                        return {
                            bucket_name: bucket.Name,
                            CreationDate: bucket.created_on,
                            region: account.info.region,
                            size: 0,
                            cost: 0,
                            id: index,
                        }
                    })
                    resolve(account)
                })
            })
        },

        update: function (cloud_account_id, project_name, info, billing_bucket) {
            let payload = {
                project_name: project_name, //,
                //info         : info
            }

            if (billing_bucket) {
                payload.billing_bucket = billing_bucket
            }

            return http.put('/cloud_accounts/' + cloud_account_id, {
                cloud_account: payload,
            })
        },

        summary: () => {
            return http.get(ANALYTICS_API + 'CloudAccount/Summary')
        },

        setBillingBucket: (cloud_account_id, bucketName) => {
            return http.put(
                '/cloud_accounts/' + cloud_account_id + '/update_billing_report_bucket',
                {
                    billing_bucket: bucketName,
                }
            )
        },

        credentials: account_id => {
            if (account_id === undefined) {
                return http.get('/cloud_accounts/access_info')
            }
            return http.get('/cloud_accounts/' + account_id + 'access_info')
        },

        users: id => http.get('/cloud_accounts/' + id + '/users'),

        validate_bucket_name: (id, bucket_name, account_type) =>
            http.get(
                '/cloud_accounts/' +
                id +
                '/storages/exists?bucket_name=' +
                bucket_name +
                '&account_type=' +
                account_type
            ),
    }
}
